
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__overview-page__/[slug]",
      function () {
        return require("private-next-pages/__overview-page__/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__overview-page__/[slug]"])
      });
    }
  